import script from "./Element3Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./Element3Icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__